<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.HolidayCreate') : $t('menu.HolidayEdit') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid background pa-4>
            <v-layout row wrap pa-4 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 class="px-1" v-if="json_data.save_type == 'create'">
                      <v-text-field :readonly="json_data.save_type != 'create'" v-model="form_model.code" :rules="form_rules.code"
                        name="รหัสโปรไฟล์" :label="$t('Holiday code')" append-icon="fas fa-plus-circle" @click:append="doNewGuid" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 class="px-1" v-if="json_data.save_type != 'create'">
                      <v-text-field readonly v-model="form_model.code" :rules="form_rules.code"
                        name="รหัสโปรไฟล์" :label="$t('Holiday code')" />
                    </v-flex>
                    <v-flex md6 sm6 xs12 class="px-1">
                      <v-text-field v-model="form_model.name" :rules="form_rules.name" name="ชื่อโปรไฟล์" :label="$t('Holiday topic')"
                        placeholder="Ex: หยุดประจำปี" />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap mt-2>
                    <v-flex md6 xs12 pa-1>
                      <v-card>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-date-picker v-model="date_picker_model.date" full-width @click:date="onDateClick()" />
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex md6 xs12 pa-1>
                      <v-layout row wrap v-for="(item, index) in form_model.events" :key="index">
                        <v-flex md5 sm5 xs5 pa-1>
                          <v-text-field v-model="item.date" label="วันที่" type="date" hide-details readonly />
                        </v-flex>
                        <v-flex md5 sm5 xs5 pa-1>
                          <v-text-field v-model="item.name" label="ชื่อ" />
                        </v-flex>
                        <v-flex md1 sm1 xs1 pa-1>
                          <v-btn color="error" flat icon @click="onRemoveItem(index)">
                            <v-icon>highlight_off</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  import SettingService from "@/services/SettingService";
  import Utils from "@/utils/";

  export default {
    props: {
      json_data: Object
    },
    watch: {
      json_data(val) {
          this.doNewGuid();
        if (val.data != null) {
          this.form_model = val.data;
        } else {
          this.$refs.form.resetValidation();
        }
      }
    },
    data: () => ({
      form_valid: false,
      form_model: {
        code: "",
        name: "",
        events: [],
        creator_code: localStorage._usercode
      },
      form_rules: {
        code: [v => !!v || "do not empty."],
        name: [v => !!v || "do not empty."]
      },
      date_picker_model: {
        date: new Date().toISOString().slice(0, 10),
        toggle: false
      },snack_model: {
        status: "",
        msg: "",
        type: ""
      }
    }),
    created: function () {
      this.doNewGuid();
    },
    methods: {
      closeDialog() {
        this.clearForm();
        this.$emit("close-dialog");
      },
      doNewGuid() {
        this.form_model.code = Utils.newGuid('HY');
      },
      clearForm() {
        this.form_model = {
          code: "",
          name: "",
          events: [],
          creator_code: localStorage._usercode
        };
      },
      showSnackBar(msg, type) {
        this.snack_model.msg = msg;
        this.snack_model.type = type;
        this.snack_model.status = true;
      },
      onDateClick() {
        let can_push = true;
        this.form_model.events.forEach(element => {
          if (this.date_picker_model.date.toString() == element.date.toString()) {
            can_push = false;
          }
        });
        if (can_push) {
          this.form_model.events.push({
            date: this.date_picker_model.date,
            name: ""
          });
        }
      },
      onRemoveItem(index) {
        this.form_model.events.splice(index, 1);
      },
      onSave() {
        if (this.form_valid) {
          this.form_model.creator_code = localStorage._usercode;
          console.log(this.form_model);
          SettingService.createHolidayPlan(this.form_model)
            .then(res => {
              this.showSnackBar('save success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        } else {
          
        }
      },
      onUpdate() {
        if (this.form_valid) {
          this.form_model.creator_code = localStorage._usercode;
          SettingService.updateHolidayPlan(this.form_model)
            .then(res => {
              this.showSnackBar('update success', 'success');
              this.closeDialog();
            })
            .catch(err => {
              this.showSnackBar(err.response.data, 'error');
            });
        }
      }
    }
  };
</script>
<style>
.v-card__text {
  padding: 0px !important;
}
</style>